/**
 * Global function to dump all component states
 * Can be called from browser console: window.dumpAllComponentStates()
 */
export function setupGlobalStateDumper() {
    // Function to get the root Vue instance
    const getRootInstance = () => {
        // Try different ways to get the root instance
        if (window.app && window.app.$root) {
            return window.app.$root;
        }

        // Look for Vue instances in the DOM
        const vueElements = document.querySelectorAll('[data-v-]');
        if (vueElements.length > 0) {
            const firstElement = vueElements[0];
            const vueInstance = firstElement.__vue__;
            if (vueInstance) {
                let root = vueInstance;
                while (root.$parent) {
                    root = root.$parent;
                }
                return root;
            }
        }

        // Try to find any Vue instance
        const allElements = document.querySelectorAll('*');
        for (let element of allElements) {
            if (element.__vue__) {
                let root = element.__vue__;
                while (root.$parent) {
                    root = root.$parent;
                }
                return root;
            }
        }

        return null;
    };

    window.dumpVuexState = function () {
        const root = getRootInstance();
        if (root && root.$store) {
            try {
                // Try namespaced getter first (main module)
                if (root.$store.getters['main/dumpAllState']) {
                    const state = root.$store.getters['main/dumpAllState'];
                    console.log('Vuex State Dump:', state);
                    return state;
                }
                // Try root level getter
                else if (root.$store.getters.dumpAllState) {
                    const state = root.$store.getters.dumpAllState;
                    console.log('Vuex State Dump:', state);
                    return state;
                } else {
                    console.warn('dumpAllState getter not found in Vuex store');
                    console.log('Available getters:', Object.keys(root.$store.getters));
                    return null;
                }
            } catch (e) {
                console.error('Error dumping Vuex state:', e);
                return null;
            }
        }
        console.warn('No Vuex store found');
        return null;
    };

    // Function to download state to a .txt file
    window.downloadStateToFile = function (data, filename = null) {
        if (!filename) {
            const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
            filename = `state-dump-${timestamp}.txt`;
        }

        const content = JSON.stringify(data, null, 2);
        const blob = new Blob([content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    // Convenience function to download Vuex state
    window.downloadVuexState = function () {
        const data = window.dumpVuexState();
        if (data) {
            window.downloadStateToFile(data, `vuex-state-${new Date().toISOString().replace(/[:.]/g, '-')}.txt`);
        }
    };
} 